import RestaurantPlaceholder from '@/components/display/restaurant-placeholder';
import { AppImage } from '@/components/ui/app-image';
import { Rating } from '@/components/ui/rating-distribution';
import { Text } from '@/components/ui/text';
import { Restaurant } from '@/types/display';
import { router } from 'expo-router';
import React, { useState } from 'react';
import { Pressable, View } from "react-native";

interface RestaurantCardProps {
    restaurant: Restaurant;
}

const RestaurantCard = React.memo(({ restaurant }: RestaurantCardProps) => {
    const [imageError, setImageError] = useState(false);
    const hasImage = !!restaurant.image && !imageError;

    const handlePress = () => {
        router.push({
            pathname: '/(root)/business/[id]',
            params: { id: restaurant.id }
        });
    };

    return (
    <Pressable className="mr-4 w-64" onPress={handlePress} accessibilityRole="button" accessibilityLabel={`View ${restaurant.name}`}>
      <View className="rounded-xl overflow-hidden border border-border bg-surface">
        {hasImage ? (
          // restaurant.image is a raw R2 key or URL; AppImage applies the
          // medium preset via imageUrl().
          <AppImage
            r2Key={restaurant.image}
            preset="medium"
            style={{ width: '100%', height: 128 }}
            onError={() => setImageError(true)}
            accessibilityLabel={`Photo of ${restaurant.name}`}
          />
        ) : (
          <RestaurantPlaceholder name={restaurant.name} width={256} height={128} />
        )}
        <View className="p-3">
          <Text className="font-bold mb-1 text-foreground">
            {restaurant.name}
          </Text>
          <View className="flex-row items-center mb-1">
            <Text className="text-xs mr-2 text-muted-foreground">
              {restaurant.cuisine}
            </Text>
            <Text className="text-xs text-muted-foreground">
              {restaurant.distance}
            </Text>
          </View>
          <View className="flex-row items-end">
            <Rating
              distribution={restaurant.ratingDistribution ?? null}
              size="sm"
            />
          </View>
        </View>
      </View>
    </Pressable>
    );
});

RestaurantCard.displayName = 'RestaurantCard';

export default RestaurantCard;
